import { lowerFirst } from 'lodash'

import { Work } from '@skinsoft/types'
import { WorkOfflineDataFetcher } from '@skinsoft/offline'
import { API_ENDPOINTS } from '@skinsoft/network'
import { EntityDataStore } from '@skinsoft/entity-data-store'

declare var WORK_SEARCH_TYPES

export class WorkDataStore extends EntityDataStore<Work> {
    public static getInstance() {
        if (!WorkDataStore.instance) {
            WorkDataStore.instance = new WorkDataStore();
        }

        return WorkDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$workDataStore = WorkDataStore.getInstance();
    }

    private static instance: WorkDataStore = null as any;

    constructor() {
        super('works', WORK_SEARCH_TYPES);
    }

    public update(id: string, body: Partial<Work>, endpointOverride?: string, ignoreCachedStatus: boolean = false) {
        let entityType = body.type ?? body.entityType
        if(entityType) {
            entityType = lowerFirst(entityType)
        }
        const endpoint = endpointOverride ?? API_ENDPOINTS[entityType as string]
        
        return super.update(id, body, endpoint, ignoreCachedStatus)
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new WorkOfflineDataFetcher(this.sanitizedIdentifer); // TODO refactor to constant
    }

    public formatDataForCaching(rawData) {
        return rawData.map(data => {
            if('work' in data) { // replace by isWemi once wemi utils is decoupled from datastores
                return data.work
            }
            return data
        })
    }
}
